module.exports = __webpack_public_path__ + "img/D2M8.a5140ad8.jpg";